import React from "react";
import styles from "./synced-org-chart.module.css";

const ShimmerGradient = ({ id }: { id: string }) => (
  <defs>
    <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="#EBEDF3" stopOpacity="1" />
      <stop offset="50%" stopColor="#f5f6f8" stopOpacity="1" />
      <stop offset="100%" stopColor="#EBEDF3" stopOpacity="1" />
      <animate attributeName="x1" from="-100%" to="100%" dur="2.2s" repeatCount="indefinite" />
      <animate attributeName="x2" from="0%" to="200%" dur="2.2s" repeatCount="indefinite" />
    </linearGradient>
  </defs>
);

export const OrgChartMappingSkeleton = () => {
  return (
    <div className={styles.mappingSection}>
      {[1, 2, 3, 4].map((index) => (
        <div key={`mapping-row-${index}`} className={styles.mappingRow}>
          <svg xmlns="http://www.w3.org/2000/svg" width="130" height="14" fill="none" viewBox="0 0 130 14">
            <ShimmerGradient id={`shimmer-label-${index}`} />
            <rect width="130" height="14" fill={`url(#shimmer-label-${index})`} rx="6"></rect>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="28" fill="none" viewBox="0 0 156 28">
            <ShimmerGradient id={`shimmer-dropdown-${index}`} />
            <rect width="156" height="28" fill={`url(#shimmer-dropdown-${index})`} rx="6"></rect>
          </svg>
        </div>
      ))}

      <div className={styles.createButtonContainer}>
        <svg xmlns="http://www.w3.org/2000/svg" width="124" height="32" fill="none" viewBox="0 0 124 32">
          <ShimmerGradient id="shimmer-button" />
          <rect width="124" height="32" fill="url(#shimmer-button)" rx="6"></rect>
        </svg>
      </div>
    </div>
  );
};
